import React from "react";
import PropTypes from "prop-types";
import { Form, A, Row } from "@contently/toolkit";

const splitArray = arr =>
  arr.reduce(
    (collector, option, i, options) => {
      const count = options.length;
      if (i < count / 2 + (count % 2)) {
        return [[...collector[0], option], [...collector[1]]];
      }
      return [[...collector[0]], [...collector[1], option]];
    },
    [[], []]
  );

const CheckboxSection = props => {
  const { options, noTranslate, onChange } = props;
  const columns = splitArray(options);

  const handleChange = (column, data, otherOptions) => {
    if (onChange) onChange([...data, ...otherOptions]);
  };

  const updateAll = checked => {
    onChange(
      options.map(opt => {
        return { ...opt, checked };
      })
    );
  };

  const generateKey = column => {
    let str = "";
    column.forEach(item => {
      str += item.value;
    });
    return str;
  };

  const renderColumns = cols =>
    cols.map(column => (
      <div key={generateKey(column)} className="sub-interaction sub-checkboxes">
        <Form.CheckboxGroup
          options={column}
          noTranslate={noTranslate}
          onChange={data => {
            handleChange(
              column,
              data,
              options.filter(o => column.indexOf(o) === -1)
            );
          }}
        />
      </div>
    ));

  let checkboxColumns = null;

  const flattened = () => {
    let columnsCopy = [...columns];
    while (columnsCopy.some(Array.isArray)) {
      columnsCopy = Array.prototype.concat.apply([], columns);
    }

    return columnsCopy;
  };

  if (flattened().length > 0) {
    checkboxColumns = renderColumns(columns);
  }

  return (
    <Row>
      <div className="select-all-nothing">
        <span>Select: </span>
        <div className="options">
          <A title="all" href="#" onClick={() => updateAll(true)}>
            All
          </A>
          <A title="none" href="#" onClick={() => updateAll(false)}>
            None
          </A>
        </div>
      </div>
      <div className="interaction">{checkboxColumns}</div>
    </Row>
  );
};

CheckboxSection.propTypes = {
  options: PropTypes.arrayOf(PropTypes.instanceOf(Object)).isRequired,
  onChange: PropTypes.func.isRequired
};

export default CheckboxSection;



// WEBPACK FOOTER //
// ./app/javascript/app/components/forms/checkboxes/checkbox_section.jsx